var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content" }, [
    _c(
      "div",
      { staticClass: "show-manage-warp" },
      [
        _c(
          "el-form",
          {
            ref: "shopForm",
            attrs: { rules: _vm.rules, model: _vm.formIn, disabled: "" },
          },
          [
            _c("div", { staticClass: "form shop-manage" }, [
              _c("div", { staticClass: "title" }, [
                _c("span", { staticClass: "text" }, [_vm._v("售后信息")]),
              ]),
              _c(
                "div",
                { staticClass: "block-content" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "consignee",
                        label: "收货人",
                        "label-width": "120px",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: {
                          size: "small",
                          placeholder: "请输入",
                          maxlength: "25",
                        },
                        model: {
                          value: _vm.formIn.consignee,
                          callback: function ($$v) {
                            _vm.$set(_vm.formIn, "consignee", $$v)
                          },
                          expression: "formIn.consignee",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "consigneePhone",
                        label: "电话",
                        "label-width": "120px",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: {
                          size: "small",
                          placeholder: "请输入",
                          maxlength: "12",
                        },
                        model: {
                          value: _vm.formIn.consigneePhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.formIn, "consigneePhone", $$v)
                          },
                          expression: "formIn.consigneePhone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "",
                        label: "省市区",
                        "label-width": "120px",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: {
                          size: "small",
                          placeholder: "请输入",
                          maxlength: "100",
                        },
                        model: {
                          value: _vm.formIn.provinceCityArea,
                          callback: function ($$v) {
                            _vm.$set(_vm.formIn, "provinceCityArea", $$v)
                          },
                          expression: "formIn.provinceCityArea",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "consigneeAddress",
                        label: "收货地址",
                        "label-width": "120px",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: {
                          size: "small",
                          placeholder: "请输入",
                          maxlength: "100",
                        },
                        model: {
                          value: _vm.formIn.consigneeAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.formIn, "consigneeAddress", $$v)
                          },
                          expression: "formIn.consigneeAddress",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "title" }, [
                _c("span", { staticClass: "text" }, [_vm._v("退换货流程")]),
              ]),
              _c(
                "div",
                { staticClass: "block-content" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "changingRefundingInstructions",
                        label: "退换货流程",
                        "label-width": "120px",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          maxlength: "2000",
                          "show-word-limit": "",
                          resize: "none",
                          rows: 6,
                          placeholder: "请输入",
                        },
                        model: {
                          value: _vm.formIn.changingRefundingInstructions,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formIn,
                              "changingRefundingInstructions",
                              $$v
                            )
                          },
                          expression: "formIn.changingRefundingInstructions",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }